export default "__VITE_ASSET__BWWyg3v3__"